import { Box } from 'vopay';
import { Title, Card } from 'UI';
import { useTranslation } from 'react-i18next';
import { TransactionHistory } from 'shared/transactionHistory';
import useTransactionsHostProps from './useTransactionsHostProps';

// Host chrome for the /transactions-history route (ID-13367). The shared TransactionHistory feature is
// chrome-less — it renders only the filter bar (export lives on the filter row), the tables and
// pagination. Per the epic, the host owns the surrounding chrome: the page title and the white card the
// feature sits in, so the same shared piece can drop into different surroundings in the Partner Portal.
export default function TransactionsHistoryPage() {
  const hostProps = useTransactionsHostProps();
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.TransactionHistory' });

  return (
    <Box flx="row" jc="center">
      <Box flx="col" gapSize="36px" width="100%">
        <Title>{t('Transactions.title', { defaultValue: 'Transactions' })}</Title>

        <Card style={{ padding: '16px' }}>
          <TransactionHistory {...hostProps} />
        </Card>
      </Box>
    </Box>
  );
}
